var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.data,"scroll":{ y: 'calc(100vh - 380px)' },"locale":{
      emptyText: _vm.$tc('lang.No_data'),
    },"pagination":{
      total: _vm.total,
      current: _vm.page,
      pageSize: _vm.size,
      onChange: _vm.onChangePage,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }